import { Typography } from '@breetometer/components';
import { CopyIcon } from 'BreetAssets';
import { RowSection } from 'BreetComponents';
import { copyToClipboard, type CURRENCYCODETYPE, CURRENCYCONFIG, formatDateTime } from 'BreetHelpers';
import { useCurrencyOutput } from 'BreetHooks';

import type { IWithdrawalsProps } from '../DialogWithdrawalHistoryDetails.helpers';
import RowBalance from './RowBalance';
import RowStatusNote from './RowStatusNote';

const WithdrawalsNuban = ({ withdrawalHistoryData }: IWithdrawalsProps) => {
	const currencyOutput = useCurrencyOutput();

	const fiatConfig = CURRENCYCONFIG[withdrawalHistoryData.currency.toUpperCase() as CURRENCYCODETYPE];
	return (
		<div className='transactiondetails_itemscontainer bg-primary-500'>
			<RowSection.Single
				label='Account Details'
				component={
					<div className='transactiondetails_value'>
						<Typography className='color-neutral-50'>
							{withdrawalHistoryData.doc.meta.accountNumber}&nbsp;&nbsp;
							<Typography
								as='span'
								className='separator color-primary-300'
							>
								|
							</Typography>
							&nbsp;&nbsp;
							{withdrawalHistoryData.doc.meta.bankName}
						</Typography>
					</div>
				}
			/>

			<RowSection.Single
				label='Account Name'
				component={
					<div className='transactiondetails_value'>
						<Typography className='color-neutral-50'>{withdrawalHistoryData.doc.meta.accountName}</Typography>
					</div>
				}
			/>

			{withdrawalHistoryData.doc.autoSettlement && withdrawalHistoryData.doc.channel === 'auto' && (
				<RowSection.Single
					label='Settlement Type'
					component={
						<div className='transactiondetails_value'>
							<Typography className='color-neutral-50'>Automatic</Typography>
						</div>
					}
				/>
			)}

			<RowSection.Single
				label='Reference ID'
				component={
					<div className='transactiondetails_value'>
						<Typography className='color-neutral-50'>{withdrawalHistoryData.doc._id}</Typography>
						<CopyIcon
							variant='colored'
							focusable
							onClick={copyToClipboard(withdrawalHistoryData.doc._id, 'Reference ID copied successfully')}
							className='cursor_pointer hide-during-screenshot'
						/>
					</div>
				}
			/>

			<RowStatusNote
				status={withdrawalHistoryData.status}
				note={withdrawalHistoryData.doc.reason}
				noteStatus={withdrawalHistoryData.status !== 'completed' ? 'error' : 'success'}
			/>

			{withdrawalHistoryData.status === 'completed' && (
				<RowBalance
					symbol={fiatConfig.symbol}
					before={currencyOutput(withdrawalHistoryData.doc.balanceBefore)}
					after={currencyOutput(withdrawalHistoryData.doc.balanceAfter)}
				/>
			)}

			{fiatConfig.code === 'NGN' && (
				<RowSection.Single
					label='Withdrawal Fee'
					component={
						<div className='transactiondetails_value'>
							<Typography className='color-neutral-50'>
								{fiatConfig.symbol}
								{currencyOutput(withdrawalHistoryData.doc.meta.fee)}
							</Typography>
						</div>
					}
				/>
			)}

			{withdrawalHistoryData.doc.meta.narration && (
				<RowSection.Single
					label='Narration'
					component={
						<div className='transactiondetails_value'>
							<Typography className='color-neutral-50'>{withdrawalHistoryData.doc.meta.narration}</Typography>
						</div>
					}
				/>
			)}

			<RowSection.Single
				label='Date'
				component={
					<div className='transactiondetails_value'>
						<Typography className='color-neutral-50'>{formatDateTime(withdrawalHistoryData.updatedAt)}</Typography>
					</div>
				}
			/>
		</div>
	);
};

export default WithdrawalsNuban;
